import React from 'react';
import { Table, Form, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TablaLicenciasPendientes = ({
    candidatasPaginadas,
    licenciasSeleccionadas,
    todasSeleccionadasPaginaActual,
    toggleSeleccionarTodo,
    toggleSeleccion,
    cargando,
    toggleOrdenColumna,
    ordenDias,
    esTieneAmbas,
    formatearFechaLarga,
    formatearFechaCorta,
    copiarAlPortapapeles,
    isAdmin = true
}) => (
    <div className="table-responsive">
        <Table striped hover className="fs--1 mb-0 align-middle text-nowrap">
            <thead className="bg-200 text-900">
                <tr>
                    {isAdmin && (
                        <th className="ps-2" style={{ width: '28px' }}>
                            <Form.Check
                                type="checkbox"
                                checked={todasSeleccionadasPaginaActual}
                                onChange={toggleSeleccionarTodo}
                                disabled={candidatasPaginadas.length === 0}
                            />
                        </th>
                    )}
                    <th>Ver</th>
                    <th>ID Licencia</th>
                    <th>Empresa</th>
                    <th>Candidata Borrado</th>
                    <th>Últ. Conexión Nube</th>
                    <th>Últ. Conexión AkasiaPOS</th>
                    <th
                        className="cursor-pointer user-select-none text-primary"
                        onClick={toggleOrdenColumna}
                        title="Haz clic para alternar orden por días vencidos (Mayor / Menor)"
                    >
                        Vencimiento / Días {ordenDias === 'DIAS_DESC' ? '↓' : '↑'}
                    </th>
                    <th>Servidor / Base de Datos</th>
                    <th>Tiene Ambas</th>
                    <th className="pe-2">UUID Empresa</th>
                </tr>
            </thead>
            <tbody>
                {candidatasPaginadas.length > 0 ? (
                    candidatasPaginadas.map((row, idx) => (
                        <tr key={row.idLicencia || idx}>
                            {isAdmin && (
                                <td className="ps-2">
                                    <Form.Check
                                        type="checkbox"
                                        checked={!!licenciasSeleccionadas.find(l => l.idLicencia === row.idLicencia)}
                                        onChange={() => toggleSeleccion(row)}
                                        disabled={row.bYaProgramada}
                                    />
                                </td>
                            )}
                            <td>
                                <Link to={"/licencias/detalle/" + row.idLicencia}>
                                    <img title="Ver información" src="/img/ver20.png" alt="Ver" height={18} />
                                </Link>
                            </td>
                            <td>
                                <div>
                                    <Link to={"/licencias/detalle/" + row.idLicencia}>
                                        <strong>{row.idLicencia}</strong>
                                    </Link>
                                    <div>
                                        {row.bLicenciaActiva ? (
                                            <Badge bg="soft-success" className="text-success px-2 py-1" title="Licencia vigente activa">
                                                ✓ Activa
                                            </Badge>
                                        ) : (
                                            <Badge bg="soft-danger" className="text-danger px-2 py-1" title="Sin licencia activa vigente">
                                                ✗ Inactiva
                                            </Badge>
                                        )}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <span className="d-inline-block text-truncate fs--1 text-800 fw-semi-bold" style={{ maxWidth: '220px' }}>
                                        {row.vNombreEmpresa || 'Sin Nombre'}
                                    </span>
                                    <div>
                                        <Badge bg={row.vTipoLicencia === 'Nube' ? 'soft-primary' : 'soft-info'} className={row.vTipoLicencia === 'Nube' ? 'text-primary' : 'text-info'}>
                                            {row.vTipoLicencia}
                                        </Badge>
                                    </div>
                                </div>
                            </td>
                            <td>
                                {(row.bEsCandidataBorrado || row.iEstatusCandidata === 1) ? (
                                    <Badge bg="soft-danger" className="text-danger px-2 py-1" title="Licencia vencida y sin uso reciente en ninguna de sus licencias">
                                        ✓ Candidata
                                    </Badge>
                                ) : (row.iEstatusCandidata === 2 || (row.iDiasVencidos > 0 && (row.bCumpleUsoNube || row.bCumpleUsoAkasiaPOS))) ? (
                                    <Badge bg="soft-warning" className="text-warning px-2 py-1" title="Licencia vencida, pero registra actividad reciente (menos de 3 meses)">
                                        Podría ser candidata
                                    </Badge>
                                ) : (
                                    <Badge bg="soft-secondary" className="text-secondary px-2 py-1" title="La licencia aún no vence o cuenta con vigencia activa">
                                        ✗ No candidata
                                    </Badge>
                                )}
                            </td>
                            <td>
                                <span className="fs--2 text-700">{formatearFechaCorta(row.dUltimaConexionNube)}</span>
                            </td>
                            <td>
                                <span className="fs--2 text-700">{formatearFechaCorta(row.dUltimaConexionAkasiaPOS)}</span>
                            </td>
                            <td>
                                <div>
                                    <div className="fs--1 text-700">{formatearFechaLarga(row.dFechaVencimiento)}</div>
                                    <div className="mt-1">
                                        <Badge bg="soft-danger" className="text-danger rounded-pill px-2 py-1">
                                            {row.iDiasVencidos} días
                                        </Badge>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <div className="text-700 fs--2">{row.vServer || 'N/A'}</div>
                                    <div className="text-700 fs--2">{row.vDatabase || 'N/A'}</div>
                                </div>
                                {row.bTieneLicenciaVigente && (
                                    <div className="mt-1 p-1 px-2 border border-warning rounded bg-white">
                                        <Badge bg="soft-warning" className="text-warning mb-1">
                                            Lic. Vigente ({row.vTipoLicenciaVigente || 'Activa'})
                                        </Badge>
                                        <div className="text-800 fs--2"><strong>Servidor:</strong> {row.vServerVigente || 'N/A'}</div>
                                        <div className="text-800 fs--2"><strong>BD:</strong> {row.vDatabaseVigente || 'N/A'}</div>
                                    </div>
                                )}
                            </td>
                            <td>
                                {esTieneAmbas(row) ? (
                                    <Badge bg="soft-warning" className="text-warning px-2 py-1" title="La empresa cuenta con licencias Nube y AkasiaPOS">
                                        ✓ Nube + POS
                                    </Badge>
                                ) : (
                                    <span className="text-700 fs--2">No</span>
                                )}
                            </td>
                            <td className="pe-2">
                                <span
                                    className="text-700 fs--2 font-monospace cursor-pointer"
                                    onClick={() => copiarAlPortapapeles(row.vUUIDEmpresa)}
                                    title="Haz clic para copiar UUID"
                                >
                                    {row.vUUIDEmpresa || 'N/A'}
                                </span>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={11} className="text-center py-4 text-muted fs--1">
                            {cargando ? 'Cargando datos...' : 'No se encontraron licencias candidatas.'}
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    </div>
);

export default TablaLicenciasPendientes;
